import * as yup from 'yup'

export function createYupSchema(validations, id) {
  let validator = yup.string()
  validations.forEach((validation) => {
    const { params, type } = validation
    if (!validator[type]) {
      return
    }
    validator = validator[type](...params)
  })
  return yup.object().shape({ [id]: validator })
}
